import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";

export default function CardTableLabaRugi({
  color,
  tableTitle,
  setData,
  formData,
  dataLaba,
  dataRugi,
  totalLaba,
  totalRugi,
  isExportable,
  dropdownTahun,
  handleSubmit,
}) {
  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                {tableTitle ? tableTitle : "Tabel Laba Rugi"}
              </h3>
            </div>
            <div></div>
          </div>
        </div>
        <div className="block overflow-x-auto">
          {/* Date Dropdown */}
          <form onSubmit={handleSubmit}>
            <div className="p-2">
              <Select
                className="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring ease-linear transition-all duration-150"
                onChange={(e) => setData(e.value)}
                options={dropdownTahun}
                // defaultValue={{ label: "a", value: "a" }}
                isSearchable={true}
                placeholder={`Pilih Tahun...`}
              />
            </div>
            <div className="p-5">
              <button
                className=" bg-lightBlue-500 text-white hover:bg-lightBlue-600 active:bg-lightBlue-900 font-bold uppercase text-xs px-6 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                type="submit"
              >
                Cek
              </button>
              {isExportable && (
                <button
                  className="mr-3 ml-3 hidden bg-gray-400 text-gray-800 active:bg-red-300 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                  type="button"
                  // onClick={() => exportPDF()}
                >
                  Cetak
                </button>
              )}
            </div>
          </form>
          <div className="items-center pb-4">
            <h1 className="text-center">
              Laporan Laba Rugi Tahun {formData.tahun}
            </h1>
          </div>
          <div>
            <table className="items-center w-full border-collapse">
              <thead>
                <tr>
                  <th
                    colSpan={3}
                    className={
                      "px-6 align-middle border-2 border-solid py-3 text-xs uppercase whitespace-nowrap font-semibold text-left " +
                      (color === "light"
                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                    }
                  >
                    Pendapatan Usaha
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataLaba.map((laba, index) => (
                  <tr key={"laba-" + index}>
                    <td className="border border-solid px-6 w-1/12 align-middle text-xs whitespace-nowrap p-4">
                      {laba.kode_akun}
                    </td>
                    <td className="border border-solid px-6 align-middle text-xs whitespace-nowrap p-4">
                      {laba.nama_akun}
                    </td>
                    <td className="border border-solid px-6 align-middle text-xs whitespace-nowrap p-4">
                      {CurrencyFormat(laba.jumlahPendapatan)}
                    </td>
                  </tr>
                ))}
                <tr className="font-bold">
                  <td className="border border-solid px-6 align-middle text-xs whitespace-nowrap p-4">
                    TOTAL PENDAPATAN
                  </td>
                  <td
                    colSpan={2}
                    className="border border-solid text-right px-6 align-middle text-xs whitespace-nowrap p-4"
                  >
                    {CurrencyFormat(totalLaba)}
                  </td>
                </tr>
              </tbody>
              {/* </table> */}
              {/* </div>
          <div> */}
              {/* <table className="items-center w-full border-collapse"> */}
              <thead>
                <tr>
                  <th
                    colSpan={3}
                    className={
                      "px-6 align-middle py-3 text-xs uppercase border-2 border-solid whitespace-nowrap font-semibold text-left " +
                      (color === "light"
                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-500"
                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                    }
                  >
                    Beban Operasional Usaha
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataRugi.map((rugi, index) => (
                  <tr key={"rugi-" + index}>
                    <td className="border-t-0 px-6 w-1/12 align-middle border border-solid text-xs whitespace-nowrap p-4">
                      {rugi.kode_akun}
                    </td>
                    <td className="border-t-0 px-6 align-middle border border-solid text-xs whitespace-nowrap p-4">
                      {rugi.nama_akun}
                    </td>
                    <td className="border-t-0 px-6 align-middle border border-solid text-xs whitespace-nowrap p-4">
                      {CurrencyFormat(rugi.jumlahBeban)}
                    </td>
                  </tr>
                ))}
                <tr className="font-bold">
                  <td className="border-t-0 px-6 align-middle border border-solid text-xs whitespace-nowrap p-4">
                    TOTAL BEBAN OPERASIONAL
                  </td>
                  <td
                    colSpan={2}
                    className="text-right border-t-0 px-6 align-middle border border-solid text-xs whitespace-nowrap p-4"
                  >
                    {CurrencyFormat(totalRugi)}
                  </td>
                </tr>
                <tr className="font-bold">
                  <td className="border-t-0 px-6 align-middle border border-solid text-xs whitespace-nowrap p-4">
                    TOTAL LABA
                  </td>
                  <td
                    colSpan={2}
                    className="text-right border-t-0 px-6 align-middle border border-solid text-xs whitespace-nowrap p-4"
                  >
                    {CurrencyFormat(totalLaba - totalRugi)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

CardTableLabaRugi.defaultProps = {
  color: "light",
};

CardTableLabaRugi.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
